/** Must match API/backend order status values exactly. */
export const ORDER_STATUS_VALUES = [
  "Refunded",
  "Accepted",
  "Partially Refunded",
  "Paid",
  "Cancelled",
  "Completed"
];
